export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5002/api';
export const REAL_TIME_API_URL = process.env.REAL_TIME_API_URL || 'http://localhost:5004';
export const UPLOADS_URL = process.env.REACT_APP_UPLOADS_URL || 'http://localhost:5002/';
export const JWT_SECRET = '123456';
export const REACT_APP_STATUS = process.env.REACT_APP_STATUS || 'offline';
export const REACT_APP_STATUS_COLOR = process.env.REACT_APP_STATUS_COLOR || 'red';
export const REACT_APP_GOOGLE_MAPS_API = process.env.REACT_APP_GOOGLE_MAPS_API || '123456';
